export default __webpack_public_path__ + "static/media/2020 (4).dffca272.jpg";